<template>
  <div class="step-container">
    <span class="step-title">Release date and source</span>
    <!--
    <span class="step-subtitle" v-if="action === 'create'">
      Paste Spotify Link for your {{ linkType }}
    </span>  
    -->
    <div class="step-content">
      <span class="description" v-if="action === 'create'">
        Start by entering the URL, ISRC, or UPC of your track and we’ll use it
        to find the links for it across popular music services
      </span>
      <div class="release-date">
        <span class="title">Release date</span>
        <div class="inputs">
          <div class="input-box date test">
            <input
              id="date-picker"
              type="date"
              v-model="source.date"
              :min="today"
            />
            <CalendarIcon class="calendar-icon" />
          </div>
          <TimeInput class="test" v-model="source.time" />
          <div
            @click="$refs.select.click()"
            class="input-box timezone-selector"
          >
            <select
              ref="select"
              v-model="source.timezone"
              class="standard-select"
            >
              <option
                v-for="(timezone, i) in timezones"
                :value="timezone"
                :key="i"
              >
                {{ timezone }}
              </option>
            </select>
            <ChevronDownIcon class="pointer-events-none" />
          </div>
        </div>
      </div>
      <template>
        <div class="input-box">
          <input
            v-model="source_input"
            type="text"
            placeholder="ISRC or UPC (Optional)"
          />
        </div>
        <div class="input-box">
          <input
            v-model="source.release_name"
            type="text"
            placeholder="Release Name"
          />
        </div>
        <span class="note">
          This is the ISRC/UPC of your track/album that you’ve selected to
          generate your link. Please note that updating this will trigger a
          rescan and reset the current services, landing page, preview, and
          metadata settings.
        </span>
        <template v-if="sourceLoaded && source.source_destination.url">
          <div class="separator"></div>
          <div class="source-card">
            <div class="source-image">
              <img :src="source.image" />
            </div>
            <div class="source-text">
              <span class="source-title">
                {{ source.artists }}
              </span>
              <span class="source-subtitle">
                {{ source.releaseTitle }}
              </span>
            </div>
          </div>
        </template>
      </template>
    </div>
    <div class="step-actions">
      <div @click="back()" class="back">
        <ArrowLeftIcon />
        <span class="back-text">BACK</span>
      </div>
      <button @click="next()" :disabled="!stepValid" class="button-default big">
        <span>Next</span>
      </button>
    </div>
    <SnackBar>
      <template v-slot:icon></template>
    </SnackBar>
  </div>
</template>
<script>
import moment from "moment-timezone";

import CalendarIcon from "../../../public/img/icons/calendar.svg";
import ChevronDownIcon from "../../../public/img/icons/chevron-down.svg";
import ArrowLeftIcon from "../../../public/img/icons/arrow-left.svg";

import SnackBar from "@/components/Custom/SnackBar";
import TimeInput from "@/components/Custom/TimeInput";

import {
  Q_GET_SPOTIFY_PREVIEW_URL,
  Q_META,
  M_RID_FROM_LINK,
  M_LINKS_FROM_RID,
} from "@/graphql";

export default {
  name: "LinkWizardPreReleaseSource",
  components: {
    ArrowLeftIcon,
    CalendarIcon,
    SnackBar,
    TimeInput,
    ChevronDownIcon,
  },
  props: ["action", "link"],
  data() {
    return {
      source_input: null,
      metadata: {},
      destination_defaults: {
        spotify: {
          name: "Spotify",
          type: "spotify",
          default_cta: "Pre-save on Spotify",
          description: "Spotify Pre-Save",
          expand: false,
          pre_release: true,
        },
        applemusic: {
          name: "Apple Music",
          type: "applemusic",
          default_cta: "Pre-add on Apple Music",
          description: "Apple Music Pre-Add",
          expand: false,
          pre_release: true,
        },
        text: {
          name: "Notify via Text",
          type: "text",
          default_cta: "Notify me via Text",
          description: "Notify via Text",
          expand: false,
          pre_release: true,
        },
        amazonmusic: {
          name: "Amazon Music",
          type: "amazonmusic",
          default_cta: "Play",
          pre_release: true,
        },
        deezer: {
          name: "Deezer",
          type: "deezer",
          default_cta: "Pre-Save",
          description: "Deezer Pre-Save",
          expand: false,
          pre_release: true,
        },
        itunes: {
          name: "iTunes",
          type: "itunes",
          default_cta: "Pre-order on iTunes",
          description: "iTunes Pre-Order",
          expand: false,
          pre_release: true,
        },
        pandora: {
          name: "Pandora",
          type: "pandora",
          default_cta: "Play",
          pre_release: true,
        },
        tidal: {
          name: "Tidal",
          type: "tidal",
          default_cta: "Play",
          pre_release: true,
        },
        soundcloud: {
          name: "SoundCloud",
          type: "soundcloud",
          default_cta: "Play",
          pre_release: true,
        },
        youtube: {
          name: "YouTube",
          type: "youtube",
          default_cta: "Watch",
          pre_release: true,
        },
        bandcamp: {
          name: "Bandcamp",
          type: "bandcamp",
          default_cta: "Download",
          pre_release: true,
        },
      },
    };
  },
  watch: {
    dateAndTime(val, old) {
      if (
        val.date === old.date &&
        val.time === old.time &&
        val.timezone === old.timezone
      )
        return;

      const offset = moment(val.date)
        .tz(val.timezone)
        .format("Z");

      console.log(`dateAndTime 2`, val.date, val.time, val.timezone, offset);

      // Specify the format for date-time string with the offset
      const dateTimeFormat = "YYYY-MM-DD hh:mm aZ";

      // Calculate the release_time
      const release_time = moment
        .parseZone(`${val.date} ${val.time}${offset}`, dateTimeFormat)
        .format();

      console.log(`release_time: ${release_time}`);

      const update = {
        date: val.date,
        time: val.time,
        timezone: val.timezone,
        offset,
        release_time,
      };

      this.$store.commit(
        this.action === "edit"
          ? "setEditLinkWizardData"
          : "setCreateLinkWizardData",
        update
      );
    },
  },
  created() {
    if (this.sourceInput) {
      this.source_input = this.sourceInput;
    }

    if (this.action !== "edit") {
      this.$store.commit("setCreateLinkWizardData", {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });
      return;
    } else if (!this.$store.state.editLinkWizardData?.id) {
      this.source_input = this.link.rid || null;
      this.$store.commit("setEditLinkWizardData", {
        ...this.link,
        source_input: this.source_input,
        link_type: this.link.type,
        source_destination: { url: "" },
      });
    }

    const zerofy = (number) => {
      if (number < 10) number = "0" + number;
      return number;
    };

    const utc = moment.utc(this.link.release_time).utcOffset(this.link.offset);
    const date =
      utc.year() + "-" + zerofy(utc.month() + 1) + "-" + zerofy(utc.date());

    const period = utc.hour() >= 12 ? "pm" : "am";
    let hour = utc.hour() > 12 ? utc.hour() - 12 : utc.hour();
    if (utc.hour() === 0) hour = 12;

    const time = zerofy(hour) + ":" + zerofy(utc.minute()) + " " + period;

    this.$store.commit("setEditLinkWizardData", {
      date,
      time,
      timezone: this.link.timezone,
    });
  },
  computed: {
    timezones() {
      return moment.tz.names();
    },
    artist() {
      return this.$store.getters.getArtist;
    },
    linkType() {
      const { link_type } =
        this.action === "edit"
          ? this.$store.state.editLinkWizardData
          : this.$store.state.createLinkWizardData;
      return link_type[0].toUpperCase() + link_type.substring(1);
    },
    sourceInput() {
      return this.$store.state.createLinkWizardData.source_input;
    },
    source() {
      return this.action == "edit"
        ? this.$store.state.editLinkWizardData
        : this.$store.state.createLinkWizardData;
    },
    sourceLoaded() {
      const data = this.source;
      return data.source_destination.url || data.rid;
    },
    today() {
      let today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },
    dateAndTime() {
      if (!this.source) return {};
      return {
        date: this.source.date,
        time: this.source.time,
        timezone: this.source.timezone,
      };
    },
    stepValid() {
      const { source, action } = this;
      if (!source.date || !source.time || !source.timezone) return false;
      // if (action !== "edit" && !source_input) return false;
      if (action !== "edit" && !source.release_name) return false;
      return true;
    },
  },
  methods: {
    back() {
      this.$emit("back");
    },
    async next() {
      try {
        if (this.source_input) await this.getMeta();
        else {
          const update = {
            release_name: this.source.release_name,
            releaseTitle: this.source.release_name,
            title: `Pre-save ${this.source.release_name}`,
            post_release_title: this.source.release_name,
            subtitle: this.artist.name,
            post_release_subtitle: this.artist.name,
            artists: this.artist.name,
            description: "",
            theme: "light",
            display_artist_socials: true,
            domain: "vibe.to",
            source_destination: {},
            destinations: [],
            autoDetectedDestinations: [],
            rid: null,
            layout: 2,
            cover_image_style: "full",
          };

          this.$store.commit(
            this.action === "edit"
              ? "setEditLinkWizardData"
              : "setCreateLinkWizardData",
            update
          );
        }
        this.$emit("setStep", this.action == "edit" ? 2 : 3);
      } catch (e) {
        console.log(e);
      }
    },
    async getSpotifyPreview(link) {
      try {
        const r = await this.$apollo.query({
          client: "localClient",
          query: Q_GET_SPOTIFY_PREVIEW_URL,
          variables: {
            link: link,
          },
        });
        console.log("Q_GET_SPOTIFY_PREVIEW_URL", r);
        const { preview_url } = r.data.get_spotify_preview_url;
        console.log(preview_url);
        // this.source.preview_url = preview_url;
        // await this.$store.dispatch("snack", {
        //   text: "Success! Spotify Preview URL saved."
        // });
        return preview_url;
      } catch (e) {
        console.log(e);
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Oops! Invalid URL.",
        });
      }
    },
    validateRid(value) {
      const isTrack = this.validateIsrc(value);
      if (isTrack) return true;
      const isAlbum = this.validateUpc(value);
      console.log({ isAlbum });
      if (isAlbum) {
        this.link_type = "album";
        return true;
      }
      return false;
    },
    validateIsrc(value) {
      return !!value.match(/^[A-Z]{2}-?\w{3}-?\d{2}-?\d{5}$/);
    },
    validateUpc(value) {
      if (!value.match(/^(\d{8}|\d{12,14})$/)) return false;

      const paddedValue = value.padStart(14, "0");

      let result = 0;
      for (let i = 0; i < paddedValue.length - 1; i += 1) {
        result += parseInt(paddedValue.charAt(i), 10) * (i % 2 === 0 ? 3 : 1);
      }

      return (10 - (result % 10)) % 10 === parseInt(paddedValue.charAt(13), 10);
    },
    async getRidFromLink() {
      const r = await this.$apollo.mutate({
        mutation: M_RID_FROM_LINK,
        client: "localClient",
        variables: {
          link: this.source_input,
        },
      });
      const { rid, type: link_type } = r.data.rid_from_link;
      return rid ? { rid, link_type } : {};
    },
    async getLinksFromRid() {
      const r = await this.$apollo.mutate({
        mutation: M_LINKS_FROM_RID,
        client: "localClient",
        variables: {
          rid: this.rid,
          type: this.link_type || "track",
        },
      });
      return r.data.links_from_rid.links || [];
    },
    async getMeta() {
      let isRid;
      isRid = this.validateRid(this.source_input);

      let destinations = [];
      let autoDetectedDestinations = [];

      if (["Release", "Pre-release"].includes(this.linkType)) {
        if (isRid) {
          this.rid = this.source_input;
          this.source_input = null;
        } else {
          await this.$store.dispatch("snack", {
            text: "Retrieving ISRC from link, please wait...",
            autoDismiss: false,
          });

          const { rid, link_type } = await this.getRidFromLink();

          if (rid) {
            this.rid = rid;
            this.link_type = link_type;
          }
        }

        if (this.rid) {
          await this.$store.dispatch("snack", {
            text: "Auto-populating links, please wait...",
            autoDismiss: false,
          });

          const links = await this.getLinksFromRid();

          let sourcePlatform = null;
          if (this.source_input) {
            sourcePlatform = new URL(this.source_input).host
              .split(".")
              .slice(-2, -1)
              .pop();
          }

          for (const { platform, url } of links) {
            if (platform === "tiktok") continue;
            const r = await this.$apollo.query({
              query: Q_META,
              client: "localClient",
              variables: { url },
            });

            const metaData = JSON.parse(r.data.meta.data);

            const destination = {
              ...this.destination_defaults[platform],
              url,
              logo: metaData.domain_image,
              type: platform,
              cta: this.destination_defaults[platform].default_cta,
              enabled: true,
              deeplink_android: metaData.deeplinks?.android || null,
              deeplink_ios: metaData.deeplinks?.ios || null,
            };

            if (platform === "spotify") {
              destination.preview_url = await this.getSpotifyPreview(url);
            }

            if (sourcePlatform && platform.includes(sourcePlatform)) {
              destinations.push(destination);
              this.source_input = url;
            }

            autoDetectedDestinations.push(destination);
          }

          // const fetchedPlatforms = links.map(({ platform }) => platform);
          // for (const [key, destination] of Object.entries(
          //   this.destination_defaults
          // )) {
          //   if (!fetchedPlatforms.includes(key)) {
          //     destinations.push({
          //       ...destination,
          //       url: null,
          //       cta: destination.default_cta,
          //       enabled: false
          //     });
          //   }
          // }
        }

        this.$store.commit("resetSnack");

        if (!this.source_input && autoDetectedDestinations.length) {
          this.source_input = autoDetectedDestinations[0].url;
        }
      }

      if (
        this.linkType !== "Pre-release" &&
        !this.source_input.includes("open.spotify.com") &&
        !this.source_input.includes("music.apple.com")
      ) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Oops! This doesn't look like a valid source link.",
        });
        this.source_input = null;
        return;
      }
      await this.$store.dispatch("snack", {
        text: "Loading metadata, please wait...",
        autoDismiss: false,
      });

      if (
        this.linkType === "Pre-release" &&
        this.source_input?.includes("/placeholder/")
      ) {
        this.source_input = this.rid;
      }

      const r = await this.$apollo.query({
        query: Q_META,
        client: "localClient",
        variables: {
          url: this.source_input || this.rid || "",
        },
      });
      this.$store.commit("resetSnack");
      let link_artist;
      const metaData = JSON.parse(r.data.meta?.data);
      console.log(metaData);
      this.metaData = metaData || {};

      let cool = false;

      // artist or user profile (BIO)
      if (this.linkType === "Bio") {
        // check if link type matches
        if (!["music.musician", "profile"].includes(metaData["og_type"])) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! This doesn't look like a Spotify artist link.",
          });
        } else if (metaData["og_url"].includes("open.spotify.com")) {
          // check if artist matches in metadata
          link_artist = metaData["og_url"]
            .split("?")[0]
            .replace("https://open.spotify.com/artist/", "");
          if (link_artist === this.artist.spotify_id) {
            cool = true;
          } else {
            await this.$store.dispatch("snack", {
              type: "error",
              text:
                "Oops! This appears to be a different artist than the one you are signed in as.",
            });
          }
        } else {
          cool = true;
        }
        // playlist (PLAYLIST)
      } else if (this.linkType === "Playlist") {
        // check if link type matches
        if (!["music.playlist"].includes(metaData["og_type"])) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! This doesn't look like a Spotify playlist link.",
          });
        } else {
          // no need to check playlist for artist match yet
          cool = true;
        }
        // song or album (RELEASE)
      } else if (this.linkType === "Release") {
        // check if link type matches
        if (!["music.song", "music.album"].includes(metaData["og_type"])) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! This doesn't look like a Spotify song or album link.",
          });
        } else {
          cool = true;
        }
      } else if (this.linkType === "Pre-release") {
        // check if link type matches
        if (!metaData["og_type"]) {
          cool = !!this.rid;
        } else if (
          !["music.song", "music.album"].includes(metaData["og_type"])
        ) {
          await this.$store.dispatch("snack", {
            type: "error",
            text: "Oops! This doesn't look like a Spotify song or album link.",
          });
          cool = false;
        } else {
          cool = true;
        }
      }

      console.log("cool", cool);

      if (cool) {
        let source_destination;

        if (
          this.linkType === "Pre-release" &&
          !(this.source_input || "").includes("/")
        ) {
          source_destination = null;
          this.source_input = this.rid;
        } else {
          const isAM = this.source_input.includes("music.apple.com");

          source_destination = isAM
            ? { name: "Apple Music", type: "applemusic" }
            : {
                name: "Spotify",
                type: "spotify",
                preview: await this.getSpotifyPreview(this.source_input),
              };
        }

        const source = {
          source_input: this.source_input,
          image: metaData["og_image"] || this.source.image,
          release_name: this.source.release_name || metaData["og_title"],
          releaseTitle: metaData["og_title"],
          title: `Pre-save ${this.source.release_name ||
            metaData["og_title"] ||
            this.source.title}`,
          post_release_title:
            this.source.release_name ||
            metaData["og_title"] ||
            this.source.post_release_title,
          subtitle:
            metaData["og_author"] || this.source.subtitle || this.artist.name,
          post_release_subtitle:
            metaData["og_author"] ||
            this.source.post_release_subtitle ||
            this.artist.name,
          artists: metaData["og_author"],
          description: "",
          theme: "light",
          display_artist_socials: true,
          domain: this.source.domain || "vibe.to",
          source_destination: {
            ...source_destination,
            logo: this.metadata["domain_image"],
            url: (this.metaData["og_url"] || "").split("?")[0],
          },
          destinations: destinations.length
            ? destinations
            : this.source.destinations,
          autoDetectedDestinations,
          rid: this.rid,
          layout: 2,
          cover_image_style: "full",
        };

        source.preReleaseDestinations = destinations.flatMap((el) => {
          if (!el.url) return [];
          return { ...el, pre_release: true };
        });

        console.log({ source });
        return this.action === "edit"
          ? this.$store.commit("setEditLinkWizardData", source)
          : this.$store.commit("setCreateLinkWizardData", source);
      } else {
        this.source_input = null;
        throw new Error("Invalid Link/ISRC/UPC");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.step-container {
  padding-top: 60px;
  display: flex;
  flex-direction: column;

  .step-title {
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: white;
    mix-blend-mode: normal;
    opacity: 0.9;
  }

  .step-subtitle {
    display: block;
    text-align: center;
    margin-top: 6px;
    /* 16/Regular */
    font-size: 16px;
    line-height: 24px;
    /* Text/type2 */
    color: $text-type-2;
  }

  .step-content {
    margin-top: 30px;
    max-width: 620px;

    .description {
      /* 16/Regular */
      font-size: 16px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
    }

    .input-box {
      margin-top: 10px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      //width: 450px;
      //width: 100;
      /* Purple-dark */
      background: $purple-dark;
      border-radius: 10px;

      .spotify-icon {
        path {
          fill: $text-type-2;
        }
      }

      input {
        z-index: 99;
        background: $purple-dark;
        flex: 1;
        padding: 12px;
        color: $text-type-2;
        border: none;
        /* 14/Regular */
        font-size: 14px;
        line-height: 17px;
        color: #b1afcd;

        &:focus {
          outline: none;
          border: none;
        }

        &::placeholder {
          color: $text-type-2;
          /* 14/Regular */
          font-size: 14px;
          line-height: 17px;
        }
      }
    }

    .release-date {
      margin-top: 30px;

      .title {
        font-size: 0.9rem;
        font-weight: 900;
        color: #8786ab;
      }

      .inputs {
        display: flex;
        align-items: baseline;

        .input-box {
          border: 1px solid #312f62;
          border-radius: 5px;
          margin-top: 10px;
          padding: 0 10px;

          input {
            padding: 12px 0;
          }
        }

        .date {
          position: relative;

          input {
            color: #b1afcd;
          }

          input::-webkit-calendar-picker-indicator {
            background: transparent;
          }

          .calendar-icon {
            position: absolute;
            z-index: 99;
            right: 10px;
            pointer-events: none;
            height: 24px;
            width: 24px;

            path {
              fill: $text-type-2;
            }
          }
        }

        .time {
          margin-top: 10px;
          margin-left: 20px;
          width: 115px;
          overflow: hidden;

          input {
            &::-webkit-calendar-picker-indicator {
              background: transparent;
            }
          }
        }

        .timezone-selector {
          margin-left: 10px;
          display: flex;
          position: relative;
          width: 50%;
          .standard-select {
            width: 100%;
          }
          select {
            padding-right: 0;
            padding-left: 0;
            margin-top: 0;
            border: 0;
          }

          svg {
            background: $purple-dark;
            width: 20px;
            right: 10px;
            top: 10px;
            position: absolute;
            z-index: 10;

            path {
              stroke: #59588d;
            }
          }
        }
      }
    }

    .note {
      /* 12/Regular */
      font-size: 12px;
      line-height: 15px;
      /* Text/type1 */
      color: $text-type-1;
      text-align: center;
    }

    .separator {
      margin-top: 30px;
      width: 100%;
      height: 1px;
      background: $purple-dark;
    }

    .source-card {
      margin-top: 30px;
      display: flex;

      .source-image {
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          /* Shadow-button */
          filter: drop-shadow(0px 0px 10px rgba(23, 18, 43, 0.45));
          border-radius: 1000px;
          width: 120px;
          height: 120px;
          object-fit: cover;
        }
      }

      .source-text {
        margin-left: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .source-title {
          /* 24/Bold */
          font-weight: bold;
          font-size: 24px;
          line-height: 32px;
          color: white;
        }

        .source-subtitle {
          /* 14/SemiBold */
          font-weight: 600;
          font-size: 14px;
          line-height: 32px;
          color: white;
        }
      }
    }
  }

  .step-actions {
    margin-top: auto;
    padding-top: 50px;
    padding-bottom: 60px;
    display: flex;
    justify-content: space-between;

    .back {
      cursor: pointer;
      display: flex;
      //flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      &:hover {
        svg {
          path {
            fill: white;
          }
        }

        .back-text {
          color: white;
        }
      }

      svg {
        width: 28px;

        path {
          fill: #8786ab;
        }
      }

      .back-text {
        font-weight: 600;
        font-size: 14px;
        line-height: 14px;
        text-transform: uppercase;
        /* Text/type2 */
        color: $text-type-2;
      }
    }

    .button-default {
      padding: 9px 40px;
    }
  }
}
@media (max-width: 768px) {
  .step-container {
    width: 80%;
    .step-content {
      .release-date {
        .inputs {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
  .timezone-selector {
    margin-left: 0 !important;
    grid-column: span 2;
    width: unset !important;
  }
  .test {
    grid-column: span 1;
  }
}
</style>
